import React from 'react';
import {
  LuLandmark,
  LuGlobe,
  LuMessageCircle,
  LuTarget,
  LuLayoutGrid,
  LuQuote,
  LuTrendingUp,
  LuUsers,
  LuArrowDown,
  LuArrowUpDown,
  LuArrowUp,
} from 'react-icons/lu';

const statBoxes = [
  { icon: LuLandmark, value: '50+', label: 'Campaign Berjalan', emphasize: false },
  { icon: LuGlobe, value: '34', label: 'Provinsi Terjangkau', emphasize: false },
  { icon: LuMessageCircle, value: 'Ribuan', label: 'Customer Conversation', emphasize: true },
  { icon: LuTarget, value: 'Berbagai', label: 'Tujuan Iklan (Traffic, Leads, Sales, Awareness)', emphasize: true },
  { icon: LuLayoutGrid, value: 'Lintas', label: 'Industri dan Skala Bisnis', emphasize: true },
];

const campaigns = [
  {
    name: 'Layanan Detailing Interior Mobil',
    tag: 'Jasa Otomotif',
    image: '/campaigns/detailing.png',
    results: '753',
    impressions: '211,154',
    reach: '78,370',
    ctr: '2.50%',
    cost: 'Rp4,065',
  },
  {
    name: 'Modern Interior',
    tag: 'Interior',
    image: '/campaigns/interior.png',
    results: '633',
    impressions: '134,303',
    reach: '57,805',
    ctr: '3.05%',
    cost: 'Rp18,293',
  },
  {
    name: 'Pembaca Isi Hati',
    tag: 'Pendidikan',
    image: '/campaigns/pembaca.png',
    results: '495',
    impressions: '72,065',
    reach: '23,670',
    ctr: '2.92%',
    cost: 'Rp6,162',
  },
  {
    name: 'Gosyen Nagih Kriuk',
    tag: 'Kuliner',
    image: '/campaigns/gosyen.jpg',
    results: '127',
    impressions: '15,790',
    reach: '10,359',
    ctr: '5.78%',
    cost: 'Rp1,371',
  },
  {
    name: 'Jasa Kebersihan Glow Up Clean',
    tag: 'Jasa',
    image: '/campaigns/clean.jpg',
    results: '68',
    impressions: '65,627',
    reach: '23,391',
    ctr: '1.07%',
    cost: 'Rp10,048',
  },
];

const clientLogos = [
  { name: 'Aslam Beauty', image: '/brands/ASLAM_BEAUTY_LAND_GOLD.png' },
  { name: 'BakmiPapaboss', image: '/brands/BakmiPapaboss.png' },
  { name: 'AHA Power', image: '/brands/AHAPower.png' },
  { name: 'CapturePro', image: '/brands/CapturePro.png' },
  { name: 'Cuan Gaming', image: '/brands/Cuan.png' },
  { name: 'Pical Niken', image: '/brands/KJPPR.png' },
  { name: 'Insight', image: '/brands/Insight.png' },
  { name: 'Mhmmd_adhaf', image: '/brands/Mhmmd_adhaf.png' },
  { name: 'MOJODREAM', image: '/brands/MOJODREAM.png' },
  { name: 'NEXTECH2', image: '/brands/NEXTECH2.png' },
  { name: 'Santre', image: '/brands/Santre.png' },
  { name: 'Talentiv', image: '/brands/Talentiv.png' },
];


function TableHeader({ children, icon: Icon = LuArrowUpDown, align = 'left', className = '' }) {
  return (
    <th className={`px-3 py-2.5 font-semibold ${className}`}>
      <span className={`flex items-center gap-1 ${align === 'right' ? 'justify-end' : ''}`}>
        {children}
        <Icon className="h-3 w-3 text-slate-400" />
      </span>
    </th>
  );
}

const CaseStudySection = () => {
  return (
    <section id="case-study" className="relative overflow-hidden bg-white px-4 py-14 md:px-6 lg:px-10 lg:py-20">
      {/* Ambient glow */}
      <div className="pointer-events-none absolute -top-32 right-0 h-[550px] w-[550px] rounded-full bg-amber-100/60 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 left-0 h-72 w-72 rounded-full bg-slate-100/70 blur-3xl" />

      <div className="relative mx-auto max-w-7xl">
        {/* Badge */}
        <span className="inline-flex items-center gap-2 rounded-full bg-amber-400 px-4 py-1.5 text-xs font-extrabold uppercase tracking-wide text-[#0F172A]">
          <LuUsers className="h-3.5 w-3.5" />
          Case Study 1
        </span>

        <div className="mt-6 grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-8">
          {/* LEFT — headline + subtext */}
          <div>
            <h2 className="font-[var(--font-display)] text-2xl font-black uppercase leading-[1.15] tracking-tight text-[#0F172A] sm:text-3xl lg:text-[2.4rem]">
              Dipercaya Berbagai Bisnis Untuk{' '}
              <span className="text-amber-500">Menghasilkan Customer</span>
            </h2>
            <div className="mt-3 h-1.5 w-16 rounded-full bg-amber-400" />

            <p className="mt-4 max-w-xl text-sm leading-relaxed text-slate-600 sm:text-base">
              SriDesain telah membantu ribuan bisnis dari berbagai industri dengan{' '}
              <span className="font-semibold text-amber-600">
                strategi iklan yang terarah dan terukur.
              </span>
            </p>
          </div>

          {/* RIGHT — trusted count card */}
          <div className="flex lg:justify-end">
            <div className="w-full max-w-xs rounded-2xl bg-gradient-to-br from-[#0F172A] to-[#1E293B] px-6 py-5 shadow-xl shadow-slate-300/40">
              <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-300">
                Sudah Dipercaya
              </p>
              <p className="mt-1 text-4xl font-extrabold text-amber-400 sm:text-5xl">12.000+</p>
              <div className="mt-3 flex items-center gap-2 border-t border-white/10 pt-3">
                <LuTrendingUp className="h-4 w-4 shrink-0 text-amber-400" />
                <p className="text-xs font-medium leading-snug text-slate-300">
                  Bisnis Dibantu di Seluruh Indonesia
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Stat boxes */}
        <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
          {statBoxes.map(({ icon: Icon, value, label, emphasize }) => (
            <div
              key={label}
              className={`rounded-2xl border p-4 text-center sm:text-left ${
                emphasize ? 'border-amber-300 bg-amber-50/60' : 'border-slate-200 bg-white'
              }`}
            >
              <span
                className={`mx-auto flex h-9 w-9 items-center justify-center rounded-lg sm:mx-0 ${
                  emphasize ? 'bg-amber-400 text-[#0F172A]' : 'bg-slate-100 text-amber-600'
                }`}
              >
                <Icon className="h-4 w-4" />
              </span>
              <p
                className={`mt-2.5 text-lg font-extrabold ${
                  emphasize ? 'text-amber-600' : 'text-[#0F172A]'
                }`}
              >
                {value}
              </p>
              <p className="text-xs leading-tight text-slate-500">{label}</p>
            </div>
          ))}
        </div>

        {/* Results table + photo/testimonial */}
        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-5 lg:gap-8">
          {/* Table */}
          <div className="lg:col-span-3">
            <div className="overflow-x-auto rounded-2xl border border-slate-200 shadow-sm shadow-slate-100">
              <table className="w-full min-w-[640px] text-left text-xs">
                <thead>
                  <tr className="border-b border-slate-200 bg-slate-50 text-slate-500">
                    <TableHeader>Campaign</TableHeader>
                    <TableHeader icon={LuArrowDown} className="text-amber-600">
                      Results
                    </TableHeader>
                    <TableHeader>Impressions</TableHeader>
                    <TableHeader>Reach</TableHeader>
                    <TableHeader>CTR (all)</TableHeader>
                    <TableHeader>Cost per result</TableHeader>
                  </tr>
                </thead>
                <tbody>
                  {campaigns.map((c, i) => (
                    <tr key={c.name} className={i % 2 === 1 ? 'bg-slate-50/60' : 'bg-white'}>
                      <td className="px-3 py-2.5">
                        <div className="flex items-center gap-2.5">
                          <img
                            src={c.image}
                            alt={c.name}
                            className="h-9 w-9 shrink-0 rounded-md border border-slate-200 object-cover"
                          />
                          <div>
                            <p className="font-semibold text-[#0F172A]">{c.name}</p>
                            <span className="mt-0.5 inline-block rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-medium text-slate-500">
                              {c.tag}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td className="px-3 py-2.5">
                        <span className="flex items-center gap-1 font-bold text-[#0F172A]">
                          {c.results}
                          <LuArrowUp className="h-3 w-3 text-green-600" />
                        </span>
                        <span className="text-[10px] font-normal text-slate-400">
                          Messaging Conversions
                        </span>
                      </td>
                      <td className="px-3 py-2.5 text-slate-600">{c.impressions}</td>
                      <td className="px-3 py-2.5 text-slate-600">{c.reach}</td>
                      <td className="px-3 py-2.5 text-slate-600">{c.ctr}</td>
                      <td className="px-3 py-2.5">
                        <span className="font-semibold text-[#0F172A] underline decoration-amber-300 decoration-2 underline-offset-2">
                          {c.cost}
                        </span>
                        <br />
                        <span className="text-[10px] font-normal text-slate-400">
                          Per Messaging Conv.
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <p className="mt-2 text-[11px] italic text-slate-400">
              *Data hasil iklan klien yang dikelola oleh SriDesain
            </p>
          </div>

          {/* Photo + quote */}
          <div className="relative lg:col-span-2">
            <div className="pointer-events-none absolute -inset-6 rounded-[2.5rem] bg-gradient-to-br from-amber-100/70 via-orange-50/40 to-transparent blur-2xl" />
            <div className="relative aspect-[4/4.6] w-full overflow-hidden rounded-[2rem]">
              {/* Ganti div ini dengan foto testimoni klien/tim Anda */}
              <img
                src="/hero-case1.png"
                alt="Tim SriDesain merekomendasikan strategi iklan yang tepat"
                className="h-full w-full object-cover"
                style={{
                  maskImage:
                    'radial-gradient(ellipse 100% 100% at center, black 68%, transparent 100%)',
                  WebkitMaskImage:
                    'radial-gradient(ellipse 100% 100% at center, black 68%, transparent 100%)',
                }}
              />
            </div>

            {/* Quote bubble */}
            <div className="absolute -bottom-4 left-1/2 w-[88%] -translate-x-1/2 rounded-2xl bg-[#0F172A] p-4 shadow-2xl shadow-slate-400/40 sm:w-4/5">
              <LuQuote className="h-5 w-5 text-amber-400" />
              <p className="mt-1.5 text-xs leading-relaxed text-slate-200 sm:text-sm">
                Setiap bisnis memiliki tantangan berbeda. Kami hadir dengan{' '}
                <span className="font-semibold text-amber-400">strategi yang tepat</span>{' '}
                untuk menghasilkan{' '}
                <span className="font-semibold text-amber-400">customer.</span>
              </p>
            </div>
          </div>
        </div>

        {/* Client logos */}
        <div className="mt-16 text-center">
          <p className="text-xs font-extrabold uppercase tracking-wide text-amber-600 sm:text-sm">
            Dipercaya oleh Berbagai Brand dan Bisnis
          </p>
           {/* Grid Logo */}
            <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
                {clientLogos.map((brand) => (
                <div
                    key={brand.name}
                    className="group flex h-20 items-center justify-center rounded-xl border border-slate-100 bg-white px-3 py-4 shadow-sm shadow-slate-200/30 transition-all duration-300 hover:scale-105 hover:border-amber-300 hover:shadow-lg hover:shadow-amber-100/50"
                >
                    <img
                    src={brand.image}
                    alt={brand.name}
                    className="max-h-10 w-auto object-contain opacity-60 grayscale transition-all duration-300 group-hover:opacity-100 group-hover:grayscale-0"
                    loading="lazy"
                    />
                </div>
                ))}
            </div>
        </div>
      </div>
    </section>
  );
};

export default CaseStudySection;